import { useEffect } from 'react';

import { Stack } from '@cast/design-system';

import { useAutoOptimization } from '../../_hooks/useAutoOptimization';
import { useOptimizeBannerVisibility } from '../../_hooks/useOptimizeBannerVisibility';
import { WizardStatusLayout } from './_components/WizardStatusLayout';
import { WizardTopBar } from '../wizard/WizardTopBar';

export const CompletedScreen = () => {
  const { onReset } = useAutoOptimization();
  const { setHidden } = useOptimizeBannerVisibility();

  useEffect(() => {
    const timer = setTimeout(() => {
      setHidden();
      onReset();
    }, 1500);
    return () => clearTimeout(timer);
  }, [onReset, setHidden]);

  return (
    <Stack height="100%">
      <WizardTopBar />
      <WizardStatusLayout variant="success" title="Done!" titleVariant="h5" />
    </Stack>
  );
};
